import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Textletter_Interface } from 'src/app/Interface/Textletter_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TextletterService {

  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<Textletter_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Text_letter").pipe(
      map(data=>{
        return data as Array<Textletter_Interface>
      })
    )
  }

  GetRelativeRecord(id:Number):Observable<Array<Textletter_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Text_letter/GetRelativeRecord?id="+id).pipe(
      map(data=>{
        return data as Array<Textletter_Interface>
      })
    )
  }

  GetSingle(id:Number):Observable<Textletter_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Text_letter/GetSingle?id="+id).pipe(
      map(data=>{
        return data as Textletter_Interface
      })
    )
  }

  AddText_letter(model: Textletter_Interface):Observable<Textletter_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      dsc:model.dsc,
      code:model.code,
      subject_id:model.subject_id,
      semat:model.semat,
      name:model.name,
      del:false,
      username:'',

    }


      return this.http.post(environment.BaseUrl + "Daro/Text_letter/Add",body,{headers}).pipe(
        map(data=>{
          return data as Textletter_Interface
        })
      )

  }

  EditText_letter(model: Textletter_Interface):Observable<Textletter_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      dsc:model.dsc,
      semat:model.semat,
      name:model.name,
      del:false,
      username:'',
    }


      return this.http.post(environment.BaseUrl + "Daro/Text_letter/Edit",body,{headers}).pipe(
        map(data=>{
          return data as Textletter_Interface
        })
      )

  }

  DeleteText_letter(id:number):Observable<Textletter_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Text_letter/Delete?id="+id).pipe(
        map(data=>{
          return data as Textletter_Interface
        })
      )

  }

  }
